export const btnstyle = {
    width: "80%",
    color: "white",
    backgroundColor: "#4dcc30",
    borderRadius: "10px",
    fontSize: "15px",
    fontWeight: "600",
    letterSpacing: 2,
    opacity: "0.9",
    "&:hover": {
      color: "white",
      backgroundColor: "#4dcc30",
      opacity: "1",
    },
  };

 export  const ContainerBox = {
    backgroundColor: "#edefe9",
    width: "100%",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
  };


 export  const StyleForLogo = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    columnGap: "10px",
  };
  

  export const styleFormainContentStack = {
    backgroundColor: "white",
    marginTop: "30px",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
  };

  export const StyleForIconToback = {
    position: "absolute",
    top: "10px",
    left: "15px",
    cursor: "poite",
    "&:hover": {
      color: "#c00000",
    },
  };

  export const StleForcodetaeedText = {
    textAlign: "center",
    paddingTop: "20px",
    fontSize: "20px",
    fontWeight: "700",
    letterSpacing: "2px",
  };

 export const StyleForConatinerInpute = {
    display: "flex",
    columnGap: "10px",
    alignItems: "Center",
    justifyContent: "center",
    gap: "15px",
    marginTop: "30px",
  };


  export const StyleForEveryInpute = {
    width: "33px",
    textAlign: "center",
    background: "#edefe9",
    borderRadius: "4px",
    borderTop: "1px solid blue",
    ".MuiInput-input": {
      textAlign: "center",
    },
  };